// extracted by mini-css-extract-plugin
module.exports = {"messageContainer":"voucher-info_messageContainer__Cr_oK"};